var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zov-popper"},[_vm._t("default"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!this.noArrow),expression:"!this.noArrow"}],ref:"zov-popper-arrow",staticClass:"zov-popper-arrow"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }